module.exports = __webpack_public_path__ + "static/media/omgivning.1d6677de.mp3";